import toast from "react-hot-toast";
import CaseDataToast from "../CaseDataLoader/CaseDataToast";
import { UploadMutationType } from "@/lib/hooks/useCaseUpload";

// // This is where we can import/export a bunch of custom toast components

let uploadToastId: string | undefined;

interface IShowCaseUploadToast {
  percent: number | null;
  uploadMutation: UploadMutationType;
}

export function ShowCaseUploadToast({
  percent,
  uploadMutation,
}: IShowCaseUploadToast) {
  uploadToastId = toast.custom(
    (t) => (
      <CaseDataToast
        percent={percent}
        toastId={t.id}
        uploadMutation={uploadMutation}
      />
    ),
    { id: uploadToastId, duration: Infinity }
  );
}

export function DismissUploadToast() {
  toast.dismiss();
  toast.remove();

  if (uploadToastId) {
    toast.dismiss(uploadToastId);
    uploadToastId = undefined;
  }
}
